<app-header
  [visibleActions]="false"
  [disableNavigationBtns]="true"
></app-header>

<main class="delete-instructions">
  <div class="delete-instructions__wrapper">
    <section>
      <h3 class="main-header">
        {{ "deleteAccount.title" | transloco | uppercase }}
      </h3>
      <p>{{ "deleteAccount.subtitle" | transloco }}</p>
    </section>

    <section>
      <h3>{{ "deleteAccount.instructionsTitle" | transloco }}</h3>
      <ul>
        <li>
          <span class="text--bolder">
            {{ "deleteAccount.dataLostKey" | transloco }}
          </span>
          {{ "deleteAccount.dataLostItem" | transloco }}
        </li>

        <li>
          <span class="text--bolder">
            {{ "deleteAccount.unrecoverableDataKey" | transloco }}
          </span>
          {{ "deleteAccount.unrecoverableDataItem" | transloco }}
        </li>

        <li>
          <span class="text--bolder">
            {{ "deleteAccount.checkTermsKey" | transloco }}
          </span>
          {{ "deleteAccount.checkTermsItem1" | transloco }}
          <a class="link" href="#/terms-of-service" target="_blank">{{
            "deleteAccount.termsOfService" | transloco
          }}</a>
          {{ "deleteAccount.checkTermsItem2" | transloco }}
        </li>
      </ul>
    </section>

    <section>
      <h3>
        {{ "deleteAccount.contactUs" | transloco }}
      </h3>
      <p>
        {{ "deleteAccount.sendUsEmail1" | transloco }}
        <span class="link">{{ "deleteAccount.emailAddress" | transloco }}</span>
        {{ "deleteAccount.sendUsEmail2" | transloco }}

        <a class="link" href="mailto:contact@em2.hr"> contact@em2.hr</a>
        {{ "deleteAccount.sendUsEmail3" | transloco }}
      </p>
    </section>

    <section>
      <p class="text--center">
        {{ "deleteAccount.thankYouParagraph" | transloco }}
      </p>
      <h3 class="text--center">{{ "deleteAccount.lomyTeam" | transloco }}</h3>
    </section>
  </div>
</main>
